import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modern-team',
  templateUrl: './modern-team.component.html',
  styleUrls: ['./modern-team.component.scss']
})
export class ModernTeamComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  teams = [
    { img: "assets/images/clienti/01.png",
      name: "Cadiviazadur",
      designation: "Faenza RA",
      description: "Il contadino a casa tua",
      url: "https://cadiviazadur.it/"
    },
    { 
      img: "assets/images/clienti/02.png",
      name: "La Nostra Medicina",
      designation: "Medicina BO",
      description: "Il vostro orto coltivato da noi",
      url: "https://www.lanostramedicina.it/"
    },
    { 
      img: "assets/images/clienti/03.png",
      name: "Fattoria il Covato",
      designation: "Pisignano RA",
      description: "La nostra passione è la terra",
      url: "https://ordina.ilcovato.it/"
    },
    { 
      img: "assets/images/clienti/04.png",
      name: "Da Madre Ignota",
      designation: "San Lazzaro di Savena BO",
      description: "Forno di Comunità",
      url: "https://ordini.damadreignota.it/"
    },
    // {
    //   img: "assets/images/app_landing2/team/2.png",
    //   name: "Ashekur Rahman",
    //   designation: "Art Dirrector",
    //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the"
    // },
    // { 
    //   img: "assets/images/app_landing2/team/3.png",
    //   name: "Ashekur Rahman",
    //   designation: "Art Dirrector",
    //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the"
    // }
  ]
  
  teamcarouselOptions= {
    items: 5,
    margin: 30,
    autoHeight: true,
    nav: false,
    dots:false,
    autoplay: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    loop: true,
    responsive: {
        0: {
            items: 1
        },
        576: {
            items: 2,
            margin: 10
        },
        991: {
            items: 3,
            margin: 10
        }
    }
  }

}
